import Label from "../Label/Label";
import ClientImg from "../../assests/img/clients.png";
import CultureImg from "../../assests/img/culture.png";
import LeaderImg from "../../assests/img/leader.png";
import MeetImg from "../../assests/img/meet.png";
import MeetImg1 from "../../assests/img/meet1.png";
import MeetImg2 from "../../assests/img/meet2.png";
import ContactUs from "../ContactUs/ContactUs";
import Footer from "../Footer/Footer";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../../pages/AboutUs/AboutUs.scss";

const sliderImages = [MeetImg, MeetImg1, MeetImg2, MeetImg1];

const sliderSettings = {
  dots: false,
  infinite: true,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 3,
  initialSlide: 0,
  responsive: [
    {
      breakpoint: 1300,
      settings: { slidesToShow: 2, slidesToScroll: 2, infinite: true, dots: false },
    },
    {
      breakpoint: 1025,
      settings: { slidesToShow: 2, slidesToScroll: 2, infinite: true, dots: false },
    },
    {
      breakpoint: 991,
      settings: { slidesToShow: 1, slidesToScroll: 1 },
    },
    {
      breakpoint: 768,
      settings: { slidesToShow: 1, slidesToScroll: 1 },
    },
    {
      breakpoint: 480,
      settings: { slidesToShow: 1, slidesToScroll: 1 },
    },
    {
      breakpoint: 300,
      settings: { slidesToShow: 1, slidesToScroll: 1 },
    },
  ],
};

const renderPoints = (points = []) => {
  const leftPoints = points.slice(0, 4);
  const rightPoints = points.slice(4, 8);

  return (
    <div className="skill_Section">
      <div className="left small50">
        {leftPoints.map((item) => (
          <Label key={item.id || item.point} title={item.point} />
        ))}
      </div>
      <div className="right small50">
        {rightPoints.map((item) => (
          <Label key={item.id || item.point} title={item.point} />
        ))}
      </div>
    </div>
  );
};

const AboutUsContent = ({ aboutData, showContactFooter = true }) => {
  if (!aboutData?.title) {
    return null;
  }

  const cardOne = aboutData.cardData?.[0] || {};
  const cardTwo = aboutData.cardData?.[1] || {};
  const leadership = aboutData.ourLeadership || {};
  const leaders = leadership.leadersData || [];
  const featuredLeader = leaders[0] || {};
  const digipankians = aboutData.someDigipankians || [];

  return (
    <div className="about_Page">
      <div className="heading_Section">
        <Label title={aboutData.title} className="about_us" />
        <Label title={aboutData.subTitle} className="about_Inner" />
      </div>

      <div className="content_Img ui_Section padd_Bottom">
        <div className="content width50">
          <Label title={cardOne.heading} className="main_Title" />
          <Label title={cardOne.paragraph} className="inner_Title" />
          {renderPoints(cardOne.points)}
        </div>
        <div className="image width50">
          <div className="img_Div">
            <img src={ClientImg} className="img_Left" alt={cardOne.heading || "Our clients"} />
          </div>
        </div>
      </div>

      <div className="content_Img ui_Section padd_Bottom">
        <div className="image width50">
          <div className="img_Div">
            <img src={CultureImg} className="img_Left" alt={cardTwo.heading || "Our culture"} />
          </div>
        </div>
        <div className="content width50">
          <Label title={cardTwo.heading} className="main_Title" />
          <Label title={cardTwo.paragraph} className="inner_Title" />
          {renderPoints(cardTwo.points)}
        </div>
      </div>

      <div className="content_Img ui_Section padd_Bottom leader_Section">
        <div className="content width20">
          <div className="skill_Section">
            <div className="left small50">
              <div className="header">
                <Label className="heading" title={leadership.heading} />
                <Label className="inner" title={leadership.subHeading} />
              </div>
              <div className="name_Designation">
                <Label className="name" title={featuredLeader.name} />
                <Label className="designation" title={featuredLeader.role} />
              </div>
              {leaders.slice(1, 5).map((leader) => (
                <div className="inner_Details" key={leader.id || leader.name}>
                  <Label className="main_Text" title={leader.name} />
                  <Label className="text" title={leader.name} />
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="image width60">
          <div className="img_Div">
            <img src={LeaderImg} className="img_Left" alt={featuredLeader.name || "Leadership team"} />
            <div className="img_Text">
              <div className="bg_Text">
                <Label className="name" title={featuredLeader.name} />
                <Label className="designation" title={featuredLeader.role} />
                <Label className="inner" title={featuredLeader.intro} />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="img_Slider">
        <Slider {...sliderSettings}>
          {digipankians.map((person, index) => (
            <div className="imgSlider" key={person.id || person.name || index}>
              <div className="imgSlider_Inner">
                <img
                  src={sliderImages[index % sliderImages.length]}
                  className="img_Left"
                  alt={person.name || "Digipank team member"}
                />
                <Label className="head" title={person.name} />
                <Label className="inner" title={person.intro} />
              </div>
            </div>
          ))}
        </Slider>
      </div>

      {showContactFooter && (
        <>
          <ContactUs />
          <Footer />
        </>
      )}
    </div>
  );
};

export default AboutUsContent;
